import { assert } from '@sparkdotfi/common-universal'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useConfig } from 'wagmi'

import { useSpkTokenRepository } from '../../common/useSpkTokenRepository'
import { getChainConfigEntry } from '@/config/chain'
import { useSandbox } from '@/domain/sandbox'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { spkStakingDataQueryOptions } from '@/features/spk/staking/logic/useSpkStakingData'

export interface UsePrefetchDialogQueriesParams {
  chainId: number
}

export function usePrefetchDialogQueries({ chainId }: UsePrefetchDialogQueriesParams): void {
  const queryClient = useQueryClient()
  const { isInSandbox } = useSandbox()
  const { account: address } = useConnectedAddress({ throwOnNotConnected: false })
  const wagmiConfig = useConfig()
  const sparkTokenConfig = getChainConfigEntry(chainId).spk
  assert(sparkTokenConfig, 'Spark token config not available for this chain')

  const tokenRepository = useSpkTokenRepository({
    chainId,
    account: address,
  })

  useEffect(() => {
    if (address) {
      void queryClient.prefetchQuery(
        spkStakingDataQueryOptions({
          chainId,
          account: address,
          wagmiConfig,
          tokenRepository,
          isInSandbox,
        }),
      )
    }
  }, [chainId, address, queryClient, wagmiConfig, tokenRepository, isInSandbox])
}
